import { Result, Spin } from "antd";
import { useAtomValue } from "jotai";
import { Navigate, useLocation } from "react-router-dom";

import { authReadyAtom, permissionsAtom } from "@/atoms/auth";
import { getToken } from "@/utils/storage";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** 路由所需权限码，空则仅需登录 */
  permission?: string;
}

/**
 * 路由守卫：校验登录态与权限
 */
export const ProtectedRoute = ({ children, permission }: ProtectedRouteProps) => {
  const authReady = useAtomValue(authReadyAtom);
  const permissions = useAtomValue(permissionsAtom);
  const location = useLocation();
  const token = getToken();

  if (!authReady) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission && !permissions.includes(permission)) {
    return <Result status="403" title="403" subTitle="暂无访问权限" />;
  }

  return <>{children}</>;
};
